import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { AppState } from '../../redux/modules';

export default connect((state: AppState) => ({
  locale: state.locale.instance.language,
  key: state.locale.instance.language,
  messages: state.locale.instance.messages,
}))(IntlProvider);
